var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: { height: _vm.screeHeight + "px" }, attrs: { id: "app" } },
    [
      _c("div", { staticClass: "boxLogin" }, [
        _vm.currImgs
          ? _c(
              "div",
              { staticClass: "borcast" },
              [
                _c(
                  "el-carousel",
                  { attrs: { height: "600px", arrow: "never" } },
                  _vm._l(_vm.currImgs, function (curImg, index) {
                    return _c("el-carousel-item", { key: index }, [
                      _c("img", {
                        attrs: { src: _vm.ImgHttps + curImg, alt: "" },
                      }),
                    ])
                  }),
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "main" },
          [
            _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
              _vm.forget
                ? _c(
                    "div",
                    { staticClass: "form" },
                    [
                      _c("p", { staticClass: "form_top" }, [
                        _c("img", {
                          attrs: {
                            src: require("../../assets/newlogo.png"),
                            alt: "",
                          },
                        }),
                      ]),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            color: "#666",
                            "font-size": "15px",
                            "padding-left": "38px",
                            "margin-bottom": "20px",
                          },
                        },
                        [_vm._v(" 欢迎登录 ")]
                      ),
                      _c(
                        "el-form",
                        {
                          ref: "loginForm",
                          attrs: { model: _vm.loginForm, rules: _vm.rules },
                        },
                        [
                          _c("el-form-item", [
                            _c(
                              "div",
                              { staticClass: "style" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/icon/icon24_sginin_xitong.png"),
                                    alt: "",
                                  },
                                }),
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "请选择系统",
                                      size: "medium",
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.loginForm.system,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.loginForm, "system", $$v)
                                      },
                                      expression: "loginForm.system",
                                    },
                                  },
                                  _vm._l(_vm.systemlist, function (items) {
                                    return _c("el-option", {
                                      key: items.dictId,
                                      attrs: {
                                        label: items.dictName,
                                        value: items.dictId,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-form-item", { attrs: { prop: "username" } }, [
                            _c(
                              "div",
                              { staticClass: "userStyle" },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入用户名",
                                    "prefix-icon": "el-icon-user",
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.submit("loginForm")
                                    },
                                  },
                                  model: {
                                    value: _vm.loginForm.username,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.loginForm, "username", $$v)
                                    },
                                    expression: "loginForm.username",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("el-form-item", { attrs: { prop: "password" } }, [
                            _c(
                              "div",
                              { staticClass: "passStyle" },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "密码",
                                    "prefix-icon": "el-icon-lock",
                                    "show-password": "",
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.submit("loginForm")
                                    },
                                  },
                                  model: {
                                    value: _vm.loginForm.password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.loginForm, "password", $$v)
                                    },
                                    expression: "loginForm.password",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "el-button",
                            {
                              class: [_vm.btnStyle == true ? "blue" : "gray"],
                              attrs: { id: "btn" },
                              on: {
                                click: function ($event) {
                                  return _vm.submit("loginForm", 2)
                                },
                              },
                            },
                            [_vm._v("登录")]
                          ),
                          _c("br"),
                          _c(
                            "div",
                            { staticClass: "info" },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  staticClass: "record",
                                  staticStyle: { color: "#a0a0a0" },
                                  model: {
                                    value: _vm.checked,
                                    callback: function ($$v) {
                                      _vm.checked = $$v
                                    },
                                    expression: "checked",
                                  },
                                },
                                [_vm._v("一周内自动登录")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _c("transition", { attrs: { name: "fade", mode: "in-out" } }, [
              !_vm.forget
                ? _c(
                    "div",
                    { staticClass: "form" },
                    [
                      _c("p", { staticClass: "form_top" }, [
                        _c("img", {
                          attrs: {
                            src: require("../../assets/newlogo.png"),
                            alt: "",
                          },
                        }),
                        _c("span", [_vm._v("五域创客工作管理系统")]),
                      ]),
                      _c(
                        "el-form",
                        {
                          ref: "forgetPass",
                          attrs: {
                            model: _vm.forgetPass,
                            rules: _vm.rulesForget,
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "username" } },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "form-input",
                                  attrs: {
                                    autocomplete: "on",
                                    placeholder: "请输入手机号",
                                  },
                                  model: {
                                    value: _vm.forgetPass.username,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.forgetPass, "username", $$v)
                                    },
                                    expression: "forgetPass.username",
                                  },
                                },
                                [
                                  _c("template", { slot: "prepend" }, [
                                    _c("i", { staticClass: "el-icon-user" }),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "password" } },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "form-input",
                                  attrs: {
                                    autocomplete: "on",
                                    placeholder: "验证码",
                                  },
                                  model: {
                                    value: _vm.forgetPass.password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.forgetPass, "password", $$v)
                                    },
                                    expression: "forgetPass.password",
                                  },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "append" },
                                    [
                                      !_vm.isShow
                                        ? _c(
                                            "span",
                                            { on: { click: _vm.start } },
                                            [_vm._v("获取验证码")]
                                          )
                                        : _vm._e(),
                                      _vm.isShow
                                        ? _c("van-count-down", {
                                            ref: "countDown",
                                            attrs: {
                                              "auto-start": false,
                                              format: "ss 秒",
                                              time: 60000,
                                            },
                                            on: { finish: _vm.finish },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", plain: "", id: "btn" },
                              on: {
                                click: function ($event) {
                                  return _vm.submit("forgetPass")
                                },
                              },
                            },
                            [_vm._v("下一步")]
                          ),
                          _c("br"),
                          _c("div", { staticClass: "info" }, [
                            _c("p", { on: { click: _vm.clance } }, [
                              _vm._v("取消"),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "bg_sginin" }, [
        _c("img", {
          style: { height: _vm.screeHeight + "px" },
          attrs: { src: require("../../assets/bg_sginin.png") },
        }),
      ]),
      _vm._m(0),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "迁移到新账号",
            "close-on-click-modal": false,
            "append-to-body": "",
            visible: _vm.setPasswordDialogVisible,
            width: "25%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.setPasswordDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formPass",
              staticStyle: { margin: "0" },
              attrs: {
                model: _vm.formPass,
                rules: _vm.rulesFormPass,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "五域账号", prop: "account" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "250px" },
                    attrs: {
                      type: "text",
                      maxlength: "24",
                      placeholder: "请输入五域账号",
                    },
                    model: {
                      value: _vm.formPass.account,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPass, "account", $$v)
                      },
                      expression: "formPass.account",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "密码", prop: "setPasswordDate" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "250px" },
                    attrs: {
                      type: "password",
                      placeholder: "请输入五域账号密码",
                    },
                    model: {
                      value: _vm.formPass.setPasswordDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPass, "setPasswordDate", $$v)
                      },
                      expression: "formPass.setPasswordDate",
                    },
                  }),
                ],
                1
              ),
              _c("span", { staticClass: "former" }, [_vm._v("（旧账号）")]),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", id: "footreBtn" },
                  on: {
                    click: function ($event) {
                      return _vm.setPasswordConfirm("formPass")
                    },
                  },
                },
                [_vm._v("绑定新账号")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hintDialog",
          attrs: {
            title: "欢迎使用五域系统V1.1.0",
            "close-on-click-modal": false,
            "append-to-body": "",
            visible: _vm.firstDialogVisible,
            width: "30%",
            "before-close": _vm.firstHandleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.firstDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "centerDialog" }, [
            _vm._v(" 欢迎使用五域系统，是否需要"),
            _c("span", { staticStyle: { color: "red" } }, [_vm._v("绑定")]),
            _vm._v("旧五域账号"),
            _c("span", { staticStyle: { color: "red" } }, [
              _vm._v("（同步订单、客户）"),
            ]),
            _vm._v("信息？如不需要或稍后绑定请关闭。 "),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { id: "later" }, on: { click: _vm.laterBinding } },
                [_vm._v("关闭")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", id: "immediately" },
                  on: { click: _vm.goGinding },
                },
                [_vm._v("前往绑定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "versions",
          attrs: {
            title: "",
            visible: _vm.versionsDialogVisible,
            width: "45%",
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.versionsDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-steps",
            {
              attrs: {
                "align-center": true,
                active: _vm.active,
                "finish-status": "success",
              },
            },
            [
              _c("el-step", { attrs: { title: "登录账号调整" } }),
              _c("el-step", { attrs: { title: "账号同步" } }),
              _c("el-step", { attrs: { title: "更新介绍" } }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active == 0,
                  expression: "active == 0",
                },
              ],
              staticClass: "one",
            },
            [
              _c("p", [_vm._v("一、登录账户调整")]),
              _c("span", [
                _vm._v(
                  "原五域账户已暂停登录，请使用钉钉手机账号登录五域系统，初始密码为手机后六位。"
                ),
              ]),
              _c(
                "div",
                { staticClass: "one_box", staticStyle: { margin: "50px 0" } },
                [
                  _c("div", { staticClass: "one_box_wu" }, [_vm._v("五")]),
                  _c("div", { staticClass: "dottedline" }),
                  _c("div", { staticClass: "dingdingBox" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/icon_dingding.png"),
                        alt: "",
                      },
                    }),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active == 1,
                  expression: "active == 1",
                },
              ],
              staticClass: "two",
            },
            [
              _c("p", [_vm._v("二、账号同步")]),
              _c("span", [_vm._v("如何同步原有五域账号客户数据、订单？")]),
              _c("div", { staticClass: "two_box" }, [
                _c("div", [
                  _c("div", { staticClass: "imgbox" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/img_2.png"),
                        alt: "",
                      },
                    }),
                  ]),
                  _c(
                    "span",
                    { staticStyle: { "font-size": "14px", color: "#666666" } },
                    [_vm._v("1.输入钉钉账号密码，点击【登录并前往绑定旧账号】")]
                  ),
                ]),
                _c("div", [
                  _c("div", { staticClass: "imgbox" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/img_3.png"),
                        alt: "",
                      },
                    }),
                  ]),
                  _c(
                    "span",
                    { staticStyle: { "font-size": "14px", color: "#666666" } },
                    [
                      _vm._v(
                        "2.输入五域账号、密码，确认无误后点击【绑定新账号】"
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active == 2,
                  expression: "active == 2",
                },
              ],
              staticClass: "three",
            },
            [
              _c("p", [_vm._v("三、更新介绍")]),
              _c(
                "p",
                { staticStyle: { "font-size": "15px", "line-height": "46px" } },
                [_vm._v("欢迎使用五域创客V1.1.0")]
              ),
              _c("p", [_vm._v("五域创客新功能升级：")]),
              _c(
                "p",
                {
                  staticStyle: {
                    "text-indent": "2em",
                    "font-size": "14px",
                    "line-height": "25px",
                  },
                },
                [
                  _vm._v(
                    " 此次升级主要针对“钉钉组织架构同步”、“物流订单统计”核心功能的上线，具体如下： "
                  ),
                ]
              ),
              _c(
                "p",
                {
                  staticStyle: {
                    "text-indent": "2em",
                    "font-size": "14px",
                    "line-height": "25px",
                  },
                },
                [
                  _vm._v(
                    " 1、上线【钉钉组织架构同步】，五域系统组织架构与钉钉保持一致，原五域账号暂停登录，改为钉钉账号登录； "
                  ),
                ]
              ),
              _c(
                "p",
                {
                  staticStyle: {
                    "text-indent": "2em",
                    "font-size": "14px",
                    "line-height": "25px",
                  },
                },
                [
                  _vm._v(
                    " 2、上线【物流订单统计】，内部系统的订单统计，可操作备货、已备货、发货、验收、导出订单等； "
                  ),
                ]
              ),
              _c(
                "p",
                {
                  staticStyle: {
                    "text-indent": "2em",
                    "font-size": "14px",
                    "line-height": "25px",
                  },
                },
                [_vm._v(" 3、五域系统进行了优化 ")]
              ),
              _c(
                "p",
                {
                  staticStyle: {
                    "text-indent": "2em",
                    "font-size": "14px",
                    "line-height": "25px",
                  },
                },
                [_vm._v(" 如有疑问，请联系相关人员或IT部，感谢😘~ ")]
              ),
              _c("p", { staticStyle: { "margin-top": "20px" } }, [
                _vm._v("物流订单统计（如下图所示)："),
              ]),
              _c(
                "div",
                {
                  staticClass: "imgbox",
                  staticStyle: { "margin-top": "20px" },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/img_dingdan.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
              },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.active != 0
                ? _c(
                    "el-button",
                    {
                      staticStyle: {
                        width: "188px",
                        color: "#3395fb",
                        border: "1px solid #3395fb",
                      },
                      on: { click: _vm.back },
                    },
                    [_vm._v("上一步")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: _vm.count == 0 ? "primary" : "info" },
                  on: { click: _vm.next },
                },
                [_vm._v(_vm._s(_vm.btnContent))]
              ),
              _vm.count != 0
                ? _c(
                    "span",
                    {
                      staticStyle: { color: "#3395fb", "margin-left": "12px" },
                    },
                    [_vm._v("倒计时" + _vm._s(_vm.count) + "s")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "keep" }, [
      _c(
        "a",
        { attrs: { href: "https://beian.miit.gov.cn", target: "_blank" } },
        [_vm._v("粤ICP备17071851号")]
      ),
      _vm._v(" "),
      _c("span", [_vm._v("版权所有 © 广东九航商业发展有限公司")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }